import type { VkPost } from '../types'

export function getVkPostElementId({ owner_id, post_id }: VkPost) {
  return `vk_post_${owner_id}_${post_id}`
}
